import Immutable from 'immutable';

export const SET_GLOBAL_ERROR = 'takeback/api/GLOBAL_ERROR';

const initialState = Immutable.Map();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case SET_GLOBAL_ERROR:
        return state.set('global', action.error);
    default: return state;
    }
}

export function getGlobalError(state) {
    return (state.errors || state).get('global');
}

export function setGlobalError(error) {
    return { type: SET_GLOBAL_ERROR, error };
}
